<template>

	<EmergencyWindow ref='_window'
		:options='{ autofocus: "ok", size: size }'
		:actions='{ header: [], tray: [ "ok" ], align: "center" }'
		:content='{ align: "center" }'
		@close='_Close'>
		<template #title><slot name='title' /></template>
		<div class='icon'><i class='fa fa-warning'></i></div>
		<slot />
	</EmergencyWindow>

</template>

<script setup>

	import { ref } from 'vue';

	import EmergencyWindow from '@/components/emergency/EmergencyWindow.vue';

	//

	const _window = ref();

	const _props = defineProps
	( {
		size:
			{
				type: String,
				default ()
				{
					return 'small';
				}
			}
	} );

	const _emit = defineEmits
	( [
		'close'
	] );

	defineExpose( { Open, Close } );

	//

	function Open ()
	{
		_window.value.Open();
	}


	function Close ()
	{
		_window.value.Close();
	}


	function _Close ()
	{
		_emit( 'close' );
	}

</script>

<style scoped>

	.icon
	{
		text-align: center;
		font-size: 3.5rem;
		margin-bottom: 1rem;
		color: var(--theme-warning);
	}

</style>